import axios from "@/api/axiosInstance";
import { GetMPDashboardResponse } from "./types";

export const getMPDashboard = async (
  intacctId: string,
): Promise<GetMPDashboardResponse> => {
  const response = await axios.get<GetMPDashboardResponse>(
    `/api/private/stochastic/market-presence-dashboard`,
    { params: { intacctId } },
  );

  return response.data;
};
